import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { catchError, filter, map, Observable, of, take, timeout } from 'rxjs';
import { LoginClaimsState } from 'src/modules/security/states/login-claims/login-claims.state';
import { CurrentAccountState } from 'src/states/current-account/current-account.state';

// Waits for account initialization (home practice/claims) before reading isAnalyticsEnabled — a plain
// selectSnapshot() here can race with login/home-account setup and incorrectly redirect on the first try.
export const analyticsGuard = (): Observable<boolean | UrlTree> => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(CurrentAccountState.initialized).pipe(
    filter(initialized => initialized),
    take(1),
    timeout(30000),
    map(() => (store.selectSnapshot(LoginClaimsState.isAnalyticsEnabled) ? true : router.parseUrl(''))),
    catchError(() => of(router.parseUrl('')))
  );
};
